import { render, staticRenderFns } from "./motorcade.vue?vue&type=template&id=92f680a4&scoped=true"
import script from "./motorcade.vue?vue&type=script&lang=js"
export * from "./motorcade.vue?vue&type=script&lang=js"
import style0 from "./motorcade.vue?vue&type=style&index=0&id=92f680a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f680a4",
  null
  
)

export default component.exports